import React from 'react';
import { StackItem, Stack } from '@domain-group/fe-blueprint-ui/layout';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../average-star-rating-and-total';
import * as styles from './recommendation-title.style';
import { useReviewsContext } from '../../recommendations-enquiry-section';
import { OverallStarRating } from '../recommendations/types';

type Props = {
  title: string;
  overallStarRating?: OverallStarRating;
};

const RecommendationTitle = ({
  title,
  overallStarRating,
}: Props): JSX.Element => {
  const { hasReviews } = useReviewsContext();
  if (hasReviews) {
    return (
      <Stack css={styles.container}>
        <StackItem
          as="h3"
          css={styles.heading}
          data-testid="recommendations_title"
        >
          {title} Reviews
        </StackItem>
        {overallStarRating && (
          <>
            <StackItem
              css={styles.separator}
              data-testid="recommendations_title-seperator"
            >
              ·
            </StackItem>
            <div css={styles.starContainer}>
              <AverageStarRatingAndTotal
                section={STAR_RATING_SECTION.RECOMMENDATIONS}
                averageRating={overallStarRating.rating}
                totalReviews={overallStarRating.totalReviews}
              />
            </div>
          </>
        )}
      </Stack>
    );
  }

  return <></>;
};

export default RecommendationTitle;
